export interface PriceFilterRange {
  from: number | null;
  to: number | null;
  type?: string;
}

export enum PriceRangeLabel {
  min = 'min',
  max = 'max'
}
